import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { CustomerUser } from '@src/app/models/customeruser'
import { Projectcomment } from '@src/app/models/comment';
import { Personproject } from '../model/personproject';
import { Project } from '@src/app/models/project';
import { Projectmember } from '../model/projectmember';
import { Stage } from '@src/app/models/stage';
import { Task } from '@src/app/models/task';


@Injectable({
  providedIn: 'root'
})
export class ProjectportalService {

  
  constructor(private http:HttpClient) { }

  createMember(project:Personproject){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }//PATCH	/projectperson/{projectId}/person/{personId}	assign
    return this.http.patch(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/'+project.projectId+"/person/"+project.personId.substr(0,36),project,httpOptions);
  }

  // /project/{projectId}/stage/list/pit/{pitdate}
  getStages(projectId:string,pit:string){
      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Stage[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/stage/list/pit/'+pit,httpOptions);
 
  
     }

  // /project/{projectId}/stage/{stageId}/pit/{pitdate}
  getStage(projectId:string,stageId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Stage>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/stage/'+stageId+'/pit/'+pit,httpOptions);
  }
  // /project/{projectId}/stage/
  addStage(stage:Stage){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+stage.projectId+'/stage/',stage,httpOptions);
  }

  // /project/{projectId}/stage/{stageId}
  editStage(stage:Stage){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+stage.projectId+'/stage/'+stage.stageId,stage,httpOptions);

  }
  // /project/{projectId}/stage/{stageId}
  deleteStage(stage:Stage){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+stage.projectId+'/stage/'+stage.stageId,httpOptions);
  }
  // /project/{projectId}/task/list/pit/{pitdate}
  getTasks(projectId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Task[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/task/list/pit/'+pit,httpOptions);
  }
  // /project/{projectId}/task/{taskId}/pit/{pitdate}
  getTask(projectId:string,taskId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Task>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/task/'+taskId+'/pit/'+pit,httpOptions);
  }

  // /project/{projectId}/task/{taskId}
  editTask(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/task/'+task.taskId,task,httpOptions);
  }
  // /project/{projectId}/task/{taskId}
  deleteTask(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+task.projectId+'/stage/'+task.taskId,httpOptions);
  }
  //
  // /organization/{organizationId}/organizationproject/{projectId}
  getProject(orgId:string,projId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project>(environment.apiUrl+'/organization/'+orgId+'/organizationproject/'+projId,httpOptions);
  }

  getCustomerMembers(projectId:string,customerId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var pit = new Date().toISOString();
    //try cast to Projectmember
    return this.http.get<Projectmember[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)

  }
  getUsers(customerId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<CustomerUser[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)

  }
  getUser(customerId:string,userId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<CustomerUser>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/'+userId+'/pit/'+pit,httpOptions)

  }
  getComments(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    
    //GET	/project/{projectId}/comment/list
    return this.http.get<Projectcomment[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/comment/list',httpOptions)
 
  }
  getProjectWithStats(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId,httpOptions);
  }
  generateStats(projectId){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<Project>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/stats/overview','',httpOptions);
  
  }
}
